import CodeEditor from "components/CodeEditor";
import FormFieldTimestamp from "components/FormFields/Timestamp";
import FormFieldViewText from "components/FormFields/ViewText";
import SpacePath from "components/SpacePath";
import TagsList from "components/TagsList";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import { Plugin } from "types/generated";

type PluginDetailsDrawerProps = {
  plugin: Plugin;
};

const PluginDetailsDrawer = createDrawer(({ plugin }: PluginDetailsDrawerProps) => {
  return (
    <DrawerSimple isDismissable>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title={plugin.name} />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody fullHeight gap="large">
        <FormFieldViewText label="Stack label" value={plugin.labelIdentifier} withCopy noMargin />
        {plugin.pluginTemplateDetails && (
          <FormFieldViewText
            label="Origin template"
            value={plugin.pluginTemplateDetails.name}
            noMargin
          />
        )}
        {plugin.description && <FormFieldViewText label="Description" value={plugin.description} />}
        <FormField label="Space" noMargin>
          <SpacePath
            variant="expandable"
            spaceId={plugin.spaceDetails.id}
            fallbackName={plugin.spaceDetails.name}
          />
        </FormField>
        <FormFieldTimestamp timestamp={plugin.createdAt} label="Created at" noMargin />
        <FormField label="Labels" noMargin>
          <TagsList tags={plugin.labels} alwaysExpanded withEmptyPlaceholder />
        </FormField>
        {plugin.manifest && (
          <FormField label="Manifest" fullHeight noMargin>
            <CodeEditor body={plugin.manifest} language="yaml" rounded readOnly />
          </FormField>
        )}
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showPluginDetailsDrawer = createDrawerTrigger(PluginDetailsDrawer);
